import { Injectable } from '@angular/core'
import {MatSnackBar} from '@angular/material/snack-bar'
import { Banniere, BanniereService } from '@helvetia/components'

@Injectable()
export class CustomErrorHandler {
  public onlineFlag = navigator.onLine

  constructor(
    public banniereService: BanniereService
  ) {}

  public handleError(err: any) {
    let message = ''
    if (err.status === 401) {
      message = 'Erreur : mauvais identifiants'
    } else if (err.error) {
      message = 'Erreur : ' + (err.error.message ? err.error.message : err.error)
    } else {
      message = 'Erreur avec le serveur (code ' + err.status + ')'
    }
    let banniere = new Banniere()
    banniere.text = message
    banniere.status = 'error'
    this.banniereService.setStatus(banniere)
  }
}
